import ProbaWorkflowsSidebar from '@/components/probaworkflows_base_components/ProbaWorklfowsSidebar/ProbaWorkflowsSidebar.vue';
import navbar from "@/components/probaworkflows_base_components/Navbar/NavBar.vue";

export default {
  name: 'ProbaWorkflowsLayout',
  components: {
    ProbaWorkflowsSidebar,
    navbar
  },
    data: () =>({
      is_sidebar_hidden: false,
      show_backdrop: false,
      isLargeScreen: window.innerWidth >= 1200
    }),

  mounted() {
    window.addEventListener("resize", this.checkScreenSize)
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.checkScreenSize)
  },
  methods: {
    toggle_sidebar() {
      this.is_sidebar_hidden = !this.is_sidebar_hidden
      this.show_backdrop = !this.is_sidebar_hidden
    },
    checkScreenSize() {
      this.isLargeScreen = window.innerWidth >= 1200
    }
  }
}
